import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmModal({ show, onClose, onConfirm, title, message, confirmLabel = 'Hapus', danger = true, loading = false }) {
  if (!show) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-body" style={{ textAlign: 'center', padding: '32px 28px' }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%',
            background: danger ? 'var(--red-bg)' : 'var(--orange-bg)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <AlertTriangle size={28} color={danger ? 'var(--red)' : 'var(--orange)'} />
          </div>
          <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{title}</h3>
          <p style={{ color: 'var(--gray-500)', fontSize: 14, lineHeight: 1.6 }}>{message}</p>
        </div>
        <div className="modal-footer" style={{ justifyContent: 'center', gap: 12 }}>
          <button className="btn btn-outline" onClick={onClose} disabled={loading} style={{ minWidth: 100 }}>
            Batal
          </button>
          <button
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
            disabled={loading}
            style={{ minWidth: 100 }}
          >
            {loading ? <span className="loader" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
